export const getQuickInsertMenuItemId = (listId: string, itemIndex: number): string =>
	`${listId}-${itemIndex}`;
